export default function ReportsPage() {
  return (
    <div className="max-w-7xl">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-foreground-900 font-heading">レポート</h2>
        <p className="text-sm text-foreground-600 mt-1">稼働率・清掃パフォーマンス分析</p>
      </div>
      <div className="bg-background-50 rounded-xl border border-background-200/70 p-12 text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-secondary-100 flex items-center justify-center">
          <i className="ri-bar-chart-line text-2xl text-secondary-600"></i>
        </div>
        <h3 className="text-lg font-semibold text-foreground-900 mb-2">レポート機能</h3>
        <p className="text-sm text-foreground-600 max-w-md mx-auto">
          この機能はPhase 4で実装予定です。稼働率推移、清掃スタッフパフォーマンス、各種レポートを提供します。
        </p>
      </div>
    </div>
  );
}